import { IService, Service } from '../core/service';

import f1 from'../../../pip/library/pi-f1/pi-f1.js';

/**
 *
 */
export interface IView extends IService {
  region: HTMLElement;

  /**
   *
   */
  mount?(region: HTMLElement): Promise<this>;

  /**
   *
   */
  unmount?(): Promise<this>;
}

/**
 * A View
 */
export class View extends Service implements IView {
  region: HTMLElement;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mount(region: HTMLElement) {
    return f1.done(this);
  }

  unmount() {
    return f1.done(this);
  }
}
